import Vue from 'vue'
/**
 * 线上
*/
import HeaderWrapper from './common/header'
import FooterWrapper from './common/footer'
/**
 * 本地测试
 * 线上代码注释
 * 测试代码打开
*/
// import HeaderApp from './components/HeaderApp.vue'
// import FooterApp from './components/FooterApp.vue'

Vue.config.productionTip = false

Vue.prototype.sendEvent = (category, label, eventName = 'button_click') => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, { event_category: category, event_label: label || '' });
  }
};

/**
 * 本地测试
 * 线上代码注释
 * 测试代码打开
*/
// new Vue({
//   render: h => h(HeaderApp),
// }).$mount('#j-bitmain-header')
// new Vue({
//   render: h => h(FooterApp),
// }).$mount('#j-bitmain-footer')

/**
 * 线上代码
 */
window.BMCommon.init({
  createHeader: (container, props) => {
    new Vue({
      render: h => h(HeaderWrapper, {
        props
      }), 
    }).$mount(container)
  },
  createFooter:(container, props) => {
    new Vue({
      render: h => h(FooterWrapper, {
        props
      }),
    }).$mount(container)
  }
})


/**
 * 该方法存在弊端
 */
// window.createBitmainHeader = (container, props) => {
//   new Vue({
//     render: h => h(HeaderWrapper, {
//       props
//     }), 
//   }).$mount(container)
// }

// window.createBitmainFooter = (container, props) => {
//   new Vue({
//     render: h => h(FooterWrapper, {
//       props
//     }),
//   }).$mount(container)
// }


// window.createBitmainFooter('#j-bitmain-footer',{
//   locale:"en"
// })


